<template>
  <div>
    <page-header
      icon="mdi-calendar-month"
      :title="$t('meal_main')"
      :subtitle="$t('manage_daily_menus')"
    >
      <template #actions>
        <v-btn
          class="mr-2"
          color="primary"
          v-if="
            user.type == 'restaurant' &&
            $store.state.restaurant &&
            $store.state.restaurant.parent &&
            $store.state.restaurant.parent.parent_menu == 1
          "
          @click="dialog1 = true"
        >
          {{ $t("meal_from") }} {{ this.$store.state.restaurant.parent.name }}
        </v-btn>

        <primary-button
          v-if="$store.state.restaurant?.add_meal == 1"
          height="40px"
          :loading="loadingMenu"
          @click="loadMenuForSpecificDate(today)"
        >
          <template v-if="todayMenu">
            {{ $t("today_menu") }}
          </template>
          <template v-else>
            <v-icon class="mr-2">mdi-plus-circle</v-icon>
            {{ $t("add_meal") }}
          </template>
        </primary-button>
      </template>
    </page-header>

    <page-toolbar :searchable="false">
      <template #filters>
        <v-col cols="auto">
          <month-picker
            class="menu-month-picker"
            v-model="selectedMonthYear"
            hide-details
            color="white"
          />
        </v-col>
      </template>
    </page-toolbar>

    <v-row v-if="loadingMeals" justify="center" align="center" style="min-height: 300px">
      <v-col cols="auto">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
      </v-col>
    </v-row>

    <div class="px-6 mt-2">
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :locale="calendarLocale"
          :events="events"
          :event-more="false"
          :event-color="getEventColor"
          :type="type"
          :weekday-format="myDayFormat"
          :weekdays="weekdays"
          @click:event="showEvent"
          @click:date="test"
        ></v-calendar>
      </v-sheet>
    </div>
    <dialog-menu
      :dates_for_disable="enteredMealDates"
      v-model="dialog"
      :selectedDate="selectedDate"
      @close="dialog = false"
      @delete="deleteItem"
      @add="addMenu"
      @select="selectMenu"
      @loadMenu="loadMenuForSpecificDate"
    ></dialog-menu>
    <dialog-menu1
      v-if="old_event"
      :new_events="events"
      :selectedDate="selectedDate"
      :old_events="old_event"
      :dialog="dialog1"
      @close="dialog1 = false"
      @select="selectMenu"
    ></dialog-menu1>
  </div>
</template>

<script>
import DialogMenu from "@/components/jelovnik/dialog";
import DialogMenu1 from "@/components/jelovnik/dialog1";
import moment from "moment";
import hasSnackbar from "@/mixins/hasSnackbar";
import menuService from "@/services/menu";
import companyService from "@/services/company";
import PageHeader from "@/components/global/PageHeader.vue";
import PageToolbar from "@/components/global/PageToolbar.vue";

export default {
  components: {
    DialogMenu,
    DialogMenu1,
    PageHeader,
    PageToolbar,
  },
  mixins: [hasSnackbar],
  data: () => ({
    loadingMeals: false,
    loadingMenu: false,
    moment,
    focus: "",
    type: "month",
    events: [],
    old_event: [],
    weekdays: [1, 2, 3, 4, 5, 6, 0],
    dialog: false,
    dialog1: false,
    selectedDate: {},
    selectedDate1: {},
    enteredMealDates: [],
    loaded: false,
    selectedMonthYear: new Date().toISOString().substr(0, 7),
    today: new Date().toISOString().substr(0, 10),
  }),
  created() {
    companyService.getUserCompanies(483);
    this.$root.$on("cloneParentMenu12", (data) => {
      if (data) {
        let startOfMonth = moment(data.date.date).startOf("month").format("YYYY-MM-DD");
        let endOfMonth = moment(data.date.date).endOf("month").format("YYYY-MM-DD");
        setTimeout(() => {
          this.getWebMonth(startOfMonth, endOfMonth);
        }, 700);
      }
    });
    this.$on("cloneParentMenuEmit", (data) => {
      let prepData = {};
      prepData["date"] = data.selected_date.date;
      if (data.parent_menu_id) {
        prepData["id"] = data.parent_menu_id;
      }
      prepData["type"] = "rucak";
      prepData["restaurant_id"] = this.$store.state.restaurant.id;
      prepData["clone_id"] = this.$store.state.restaurant.parent.id;
      prepData["reserve_id"] = "";
      prepData["one"] = 0;
      prepData["meals"] = [];
      prepData["meals"]["restaurant_id"] = this.$store.state.restaurant.id;
      prepData["meals"]["menu_id"] = data.restoran_parent_id;
      data.selected_date.meals.filter((meal) => {
        if (data.selected_meals.includes(meal.id)) {
          if (data.parent_menu_id) {
            meal.old_menu_id = meal.menu_id;
            meal.clone_meal_id = meal.id;
            meal.menu_id = data.parent_menu_id;
            meal.restaurant_id = this.$store.state.restaurant.id;
            meal.clone_id = this.$store.state.restaurant.parent.id;
            meal.id = "";
          }
          prepData["meals"].push(meal);
        }
      });
      this.addMenu(prepData);
    });
    if (
      this.user &&
      this.user.restaurants &&
      this.user.restaurants.length &&
      this.user.restaurants[0].parent &&
      this.user.restaurants[0].parent.parent_menu == 1 &&
      this.user.type == "restaurant"
    ) {
      menuService
        .getCloneableMenus({
          id: this.user.restaurants[0].parent_id,
          usr_id: this.user.id,
        })
        .then((res) => {
          res.data.forEach((item) => {
            const min = new Date(`${item.date}T00:00:01`);
            const max = new Date(`${item.date}T23:59:59`);
            this.old_event.push({
              id: item.id,
              name: this.translateName(item.type),
              date: item.date,
              reserve_id: item.reserve_id,
              start: min,
              end: max,
              color: this.color(item.type),
              timed: false,
              meals: item.meals,
              one: item.one ? 1 : 0,
            });
          });
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_cloneable_menus"));
        });
    }
    this.getWeb();
  },
  methods: {
    getWeb(date = new Date()) {
      this.enteredMealDates = [];
      this.events = [];
      let startOfMonth = moment(date).startOf("month").format("YYYY-MM-DD");
      let endOfMonth = moment(date).endOf("month").format("YYYY-MM-DD");

      // Set calendar focus to the correct month based on the date
      this.focus = moment(date).format("YYYY-MM-DD");

      this.enteredMealDates = [];
      this.loadingMeals = true;
      return menuService
        .getWebAppOnlyMenu(startOfMonth, endOfMonth)
        .then((res) => {
          res.data.forEach((item) => {
            const min = new Date(`${item.date}T00:00:01`);
            const max = new Date(`${item.date}T23:59:59`);
            this.enteredMealDates.push(item.date);
            this.events.push({
              id: item.id,
              name: this.translateName(item.type),
              date: item.date,
              reserve_id: item.reserve_id,
              start: min,
              end: max,
              color: this.color(item.type),
              timed: false,
              meals: item.meals,
              one: item.one ? 1 : 0,
            });
          });
          this.loadingMeals = false;
        })
        .catch(() => {
          this.loadingMeals = false;
          this.showErrorSnackbar(this.$t("error_loading_menus"));
        });
    },
    getWebMonth(startOfMonth, endOfMonth) {
      this.events = [];
      this.enteredMealDates = [];
      this.loadingMeals = true;
      menuService
        .getWebAppOnlyMenu(startOfMonth, endOfMonth)
        .then((res) => {
          res.data.forEach((item) => {
            const min = new Date(`${item.date}T00:00:01`);
            const max = new Date(`${item.date}T23:59:59`);
            // item.meals.forEach(el=>{
            //   el.type=el.groups.map(i=>i.group);
            // })

            this.enteredMealDates.push(item.date);
            this.events.push({
              id: item.id,
              name: this.translateName(item.type),
              date: item.date,
              reserve_id: item.reserve_id,
              start: min,
              end: max,
              color: this.color(item.type),
              timed: false,
              meals: item.meals,
              one: item.one ? 1 : 0,
            });
          });
          this.loadingMeals = false;
        })
        .catch(() => {
          this.loadingMeals = false;
          this.showErrorSnackbar(this.$t("error_loading_menus"));
        });
      this.$forceUpdate();
    },
    translateName(name) {
      let ime = "";
      if (name == "rucak") {
        ime = this.$t("rucak");
      } else {
        ime = name;
      }
      return ime;
    },
    test(data) {
      let check = this.events.find((item) => item.date === data.date);
      if (!check) {
        this.selectedDate = {
          date: data.date,
          meals: [],
          name: "rucak",
        };
        this.dialog = true;
      }
    },
    color(type) {
      switch (type) {
        case "dorucak":
          return "green";
        case "rucak":
          return "blue";
        case "vecera":
          return "red";
      }
    },
    loadMenuForSpecificDate(date) {
      const eventDate = this.events.find((event) => event.date === date);
      if (eventDate) {
        this.loadMenu(eventDate.id);
      } else {
        this.selectedDate = {
          date,
          meals: [],
          name: "rucak",
        };
        this.dialog = true;
      }
    },
    selectMenu(data) {
      if (data) {
        this.selectedDate = data;
        this.selectedDate.name = data.type;
      }
    },
    addMenu(data) {
      if (data.id) {
        this.handleRequest(menuService.updateMenu(data.id, data), {
          loadingMessage: this.$t("updating_menu"),
          successMessage: this.$t("menu_updated_successfully"),
          errorMessagePrefix: this.$t("error_updating_menu") + ": ",
        })
          .then((res) => {
            this.loadMenu(data.id);
          })
          .catch((error) => {
            if (error.response?.data?.status == "failed") {
              this.$root.$emit("errorMessage", error.response.data);
            }
          });
      } else {
        this.handleRequest(menuService.createMenu(data), {
          loadingMessage: this.$t("creating_menu"),
          successMessage: this.$t("menu_created_successfully"),
          errorMessagePrefix: this.$t("error_creating_menu") + ": ",
        })
          .then(async (res) => {
            await this.getWeb(res.data.date);
            this.loadMenuForSpecificDate(res.data.date);
            // }
          })
          .catch((error) => {
            // Additional error handling if needed
            console.error("Menu creation error:", error);
          });
      }
    },
    deleteItem(id) {
      if (id) {
        menuService
          .deleteMenu(id)
          .then((res) => {
            this.showSuccessSnackbar(this.$t("menu_deleted"));
            this.selectedDate = {};
            this.dialog = false;
            this.events.splice(
              this.events.findIndex((el) => el.id === id),
              1
            );
          })
          .catch((error) => {
            if (error.response?.data?.status == "failed") {
              this.showErrorSnackbar(
                error.response.data.message || this.$t("error_deleting_menu")
              );
              this.$root.$emit("errorMessage", error.response.data, "menu");
            } else {
              this.showErrorSnackbar(this.$t("error_deleting_menu"));
            }
          });
      }
    },
    myDayFormat(day) {
      switch (day.weekday) {
        case 1:
          return this.$t("monday");
        case 2:
          return this.$t("tuesday");
        case 3:
          return this.$t("wednesday");
        case 4:
          return this.$t("thursday");
        case 5:
          return this.$t("friday");
        case 6:
          return this.$t("saturday");
        case 0:
          return this.$t("sunday");
      }
    },
    getEventColor(event) {
      return (event.color = "primary");
    },
    loadMenu(id) {
      this.loadingMenu = true;
      menuService
        .getMenuById(id, true)
        .then((res) => {
          this.selectedDate = {
            ...res.data,
            meals: (res.data.meals || []).map((meal) => {
              return {
                ...meal,
                type: meal.groups.map((i) => i.menu_type_id),
              };
            }),
          };
          this.dialog = true;
        })
        .catch(() => {
          this.showErrorSnackbar(this.$t("error_loading_menu"));
        })
        .finally(() => {
          this.loadingMenu = false;
        });
    },
    showEvent({ nativeEvent, event }) {
      this.loadMenu(event.id);
    },
  },
  computed: {
    todayMenu() {
      return this.events.find((event) => event.date === this.today);
    },
    user() {
      return this.$store.state.user.user;
    },
    calendarLocale() {
      switch (this.$i18n.locale) {
        case "sr-lat":
        case "rs-lat":
          return "sr-Latn-RS";
        case "sr":
        case "rs":
          return "sr-Cyrl-RS";
        case "bs":
          return "bs-BA";
        case "hr":
          return "hr-HR";
        case "en":
          return "en-GB";
        default:
          return this.$i18n.locale;
      }
    },
  },
  watch: {
    "$i18n.locale"() {
      if (this.loaded) this.getWeb();
      else this.loaded = true;
    },
    selectedMonthYear(newValue) {
      if (newValue) {
        const selectedDate = moment(newValue, "YYYY-MM").toDate();
        this.getWeb(selectedDate);
      }
    },
  },
};
</script>
